import { css } from 'styled-components';
import { WithDisabled } from "models/app/common";

export const disablePointer = ({ disabled }: WithDisabled) => disabled === true ? css`pointer-events: none; cursor: unset;` : css`cursor: pointer;`;
export const disableCursor = ({ disabled }: WithDisabled) => disabled === true ? css`cursor: unset;` : css`cursor: pointer;`;
